"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThorTxInfo = void 0;
const api_1 = require("../../../../../api");
const getInboundAddressDataForChain_1 = require("../../getInboundAddressDataForChain");
const getLimit_1 = require("../../getLimit/getLimit");
const makeSwapMemo_1 = require("../../makeSwapMemo/makeSwapMemo");
const getThorTxInfo = async ({ deps, sellAsset, buyAsset, sellAmountCryptoBaseUnit, slippageTolerance, destinationAddress, xpub, buyAssetTradeFeeUsd, }) => {
    try {
        const inboundAddress = await (0, getInboundAddressDataForChain_1.getInboundAddressDataForChain)(deps.daemonUrl, sellAsset.assetId);
        const vault = inboundAddress === null || inboundAddress === void 0 ? void 0 : inboundAddress.address;
        if (!vault)
            throw new api_1.SwapError(`[getThorTxInfo]: vault not found for asset`, {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
                details: { inboundAddress, sellAsset },
            });
        const limit = await (0, getLimit_1.getLimit)({
            buyAssetId: buyAsset.assetId,
            sellAmountCryptoBaseUnit,
            sellAsset,
            slippageTolerance,
            deps,
            buyAssetTradeFeeUsd,
        });
        const memo = (0, makeSwapMemo_1.makeSwapMemo)({
            buyAssetId: buyAsset.assetId,
            destinationAddress,
            limit,
        });
        return {
            opReturnData: memo,
            vault,
            pubkey: xpub,
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[getThorTxInfo]', { cause: e, code: api_1.SwapErrorTypes.TRADE_QUOTE_FAILED });
    }
};
exports.getThorTxInfo = getThorTxInfo;
